<div class="space-y-3">
  @if (showTitle()) {
    <div class="flex items-center justify-between flex-wrap gap-2">
      <span class="text-xs font-bold text-neutral-12 uppercase tracking-wider flex items-center gap-1.5">
        <mat-icon class="!w-4 !h-4 !text-base text-primary-9">schedule</mat-icon>
        {{ title() }}
      </span>

      <span
        class="text-xs font-bold px-2.5 py-1 rounded-full border inline-flex items-center gap-1.5 shadow-2xs"
        [class]="openingHoursStatus().badgeClass"
      >
        <span
          class="w-2 h-2 rounded-full"
          [class.bg-primary-9]="openingHoursStatus().isOpen"
          [class.bg-neutral-6]="!openingHoursStatus().isOpen"
        ></span>
        {{ openingHoursStatus().text }}
      </span>
    </div>
  }

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2.5">
    @for (day of weekSchedule(); track day.key) {
      <div
        class="p-3 rounded-xl border text-xs flex flex-col gap-1 transition-all shadow-2xs"
        [class.bg-primary-1]="day.isToday && day.isOpen"
        [class.border-primary-4]="day.isToday && day.isOpen"
        [class.bg-white]="!day.isToday || !day.isOpen"
        [class.dark:bg-neutral-2]="!day.isToday || !day.isOpen"
        [class.border-neutral-3]="!day.isToday || !day.isOpen"
        [class.dark:border-neutral-4]="!day.isToday || !day.isOpen"
      >
        <div class="flex items-center justify-between">
          <span class="font-bold text-neutral-12 flex items-center gap-1">
            {{ day.label }}
            @if (day.isToday) {
              <span class="text-[9px] font-bold px-1.5 py-0.2 rounded bg-primary-3 text-primary-11"
                >Aujourd'hui</span
              >
            }
          </span>
          @if (!day.isOpen) {
            <span class="text-[10px] text-neutral-8 font-medium">Fermé</span>
          }
        </div>
        <span
          class="text-[11px] leading-tight"
          [class.text-neutral-11]="day.isOpen"
          [class.text-neutral-8]="!day.isOpen"
          [class.italic]="!day.isOpen"
        >
          {{ day.statusText }}
        </span>
      </div>
    }
  </div>

  @if (hours()?.notes) {
    <p
      class="text-xs text-neutral-10 italic bg-white dark:bg-neutral-2 p-3 rounded-xl border border-neutral-3 dark:border-neutral-4 shadow-2xs"
    >
      <span class="font-bold not-italic text-neutral-12">Note : </span>{{ hours()!.notes }}
    </p>
  }
</div>
